import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'

interface DocumentFilterState {
  contactIds: string[]
  documentTypeId: string | null
  createdByUserIds: string[] | null
  startDate: Date | null
  endDate: Date | null
}

const initialState: DocumentFilterState = {
  contactIds: [],
  documentTypeId: null,
  createdByUserIds: null,
  startDate: null,
  endDate: null,
}

interface ResetDocumentFiltersPayload {
  keepContactIds?: boolean
}

export const documentFilterSlice = createSlice({
  name: 'documentFilter',
  initialState,
  reducers: {
    setDocumentContactsFilter: (state, action: PayloadAction<string[]>) => {
      state.contactIds = action.payload
    },
    setDocumentTypeFilter: (state, action: PayloadAction<string | null>) => {
      state.documentTypeId = action.payload
    },
    setDocumentCreatedByFilter: (state, action: PayloadAction<string[]>) => {
      state.createdByUserIds = action.payload
    },
    setDocumentStartDateFilter: (state, action: PayloadAction<Date | null>) => {
      state.startDate = action.payload
    },
    setDocumentEndDateFilter: (state, action: PayloadAction<Date | null>) => {
      state.endDate = action.payload
    },
    resetDocumentFilters: (state, action: PayloadAction<ResetDocumentFiltersPayload | undefined>) => ({
      ...initialState,
      contactIds: action.payload?.keepContactIds ? state.contactIds : initialState.contactIds,
    }),
  },
})

export const {
  setDocumentContactsFilter,
  setDocumentTypeFilter,
  setDocumentCreatedByFilter,
  setDocumentStartDateFilter,
  setDocumentEndDateFilter,
  resetDocumentFilters,
} = documentFilterSlice.actions

export const selectDocumentContactsFilter = (state: RootState) => state.processDocument.documentFilter.contactIds

export const selectDocumentTypeFilter = (state: RootState) => state.processDocument.documentFilter.documentTypeId

export const selectDocumentCreatedByFilter = (state: RootState) => state.processDocument.documentFilter.createdByUserIds

export const selectDocumentStartDateFilter = (state: RootState) => state.processDocument.documentFilter.startDate

export const selectDocumentEndDateFilter = (state: RootState) => state.processDocument.documentFilter.endDate
